var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotesBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7375 38.8113C43.7375 34.2526 45.6477 29.8806 49.0478 26.6571C52.4478 23.4336 57.0593 21.6227 61.8677 21.6227V0C61.8677 0 79.9999 12.5981 79.9999 38.8113C79.9493 43.3387 78.0167 47.6644 74.622 50.8489C71.2272 54.0334 66.6444 55.8196 61.8687 55.8196C57.0931 55.8196 52.5103 54.0334 49.1155 50.8489C45.7207 47.6644 43.7882 43.3387 43.7375 38.8113Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.8113C0 34.2526 1.91014 29.8806 5.31021 26.6571C8.71027 23.4336 13.3218 21.6227 18.1302 21.6227V0C18.1302 0 36.2624 12.5981 36.2624 38.8113C36.2117 43.3387 34.2792 47.6644 30.8844 50.8489C27.4897 54.0334 22.9068 55.8196 18.1312 55.8196C13.3555 55.8196 8.77271 54.0334 5.37796 50.8489C1.9832 47.6644 0.0506496 43.3387 0 38.8113Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesBottom);
export default __webpack_public_path__ + "static/media/QuotesBottom.d0a89f9d2c09d1bd75daa095594022ae.svg";
export { ForwardRef as ReactComponent };